import { TabItem } from '@vyce/core/src/types';

export const FORMS_TABS: TabItem[] = [
  {
    label: 'Forms',
    link: '/forms/my-forms',
  },
  {
    label: 'Templates',
    link: '/forms/form-templates',
  },
  // {
  //   label: 'Forms to answer',
  //   link: '/forms/forms-to-answer',
  // },
];

export const ItemTypes = {
  FORM_QUESTION: 'formQuestion',
} as const;
